// extracted by mini-css-extract-plugin
module.exports = {"paymentHistoryYear":"styles_paymentHistoryYear__1juZ8","browser-ie":"styles_browser-ie__3zZbu","closed":"styles_closed__1ge2Q","animating":"styles_animating__CRvL-"};